// packages/frontend/src/components/LoadingScreen.tsx
export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-dark-950">
      <div className="text-center">
        <div className="mb-4 inline-flex h-12 w-12 animate-spin items-center justify-center rounded-full border-4 border-dark-700 border-t-primary-500">
        </div>
        <h2 className="text-xl font-semibold text-white">Vendetta DB</h2>
        <p className="text-dark-400">Loading your files...</p>
      </div>
    </div>
  )
}